<script setup>
// Wrapper around saas-core's AdminUsers list. AdminUsers itself emits
// `invite` and `edit` events and expects the parent to render the actual
// modal components (`InviteUserModal`, `EditUserModal`). Mounting AdminUsers
// directly as a route meant those emits went nowhere — buttons appeared
// to do nothing.
//
// This wrapper:
//   - listens for `invite` and `edit` from AdminUsers
//   - renders InviteUserModal / EditUserModal as siblings
//   - bumps a `key` on AdminUsers after modal completion so the list reloads
//     (AdminUsers doesn't expose its loadUsers() via defineExpose, so a key
//      bounce is the simplest way to re-fetch)
import { ref } from "vue";
import AdminUsers from "@digitalstreams/saas-core/vue/admin/AdminUsers.vue";
import InviteUserModal from "@digitalstreams/saas-core/vue/admin/InviteUserModal.vue";
import EditUserModal from "@digitalstreams/saas-core/vue/admin/EditUserModal.vue";

const showInvite = ref(false);
const showEdit = ref(false);
const editingUser = ref(null);

// Bumped after any modal-driven mutation so AdminUsers refetches.
const reloadKey = ref(0);

function onInvite() {
  showInvite.value = true;
}

function onEdit(user) {
  editingUser.value = user;
  showEdit.value = true;
}

function onInvited() {
  // Modal closes itself ~1.5s after success; refresh once the close fires.
}

function onUpdated() {
  // Modal closes itself ~1s after success; refresh once the close fires.
}

function onInviteClose() {
  showInvite.value = false;
  reloadKey.value++;
}

function onEditClose() {
  showEdit.value = false;
  editingUser.value = null;
  reloadKey.value++;
}
</script>

<template>
  <AdminUsers
    :key="reloadKey"
    @invite="onInvite"
    @edit="onEdit"
  />
  <InviteUserModal
    :show="showInvite"
    @close="onInviteClose"
    @invited="onInvited"
  />
  <EditUserModal
    :show="showEdit"
    :user="editingUser || {}"
    @close="onEditClose"
    @updated="onUpdated"
  />
</template>
